/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Method_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Microsoft account (SSO)" |
*
* @param {Members_Add_Method_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_method_microsoft = /** @type {((inputs?: Members_Add_Method_MicrosoftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Method_MicrosoftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Microsoft-Konto (SSO)")
	return /** @type {LocalizedString} */ ("Microsoft account (SSO)")
});